// External.
import { useEffect, useRef, useState } from "react";

// NVIDIA.
import { Icon, Textbox } from "@kaizen-ui/complete";

// Local.
import { DocumentService } from "../services/document-service";
import type { Documentation } from "../services/document-service";
import { DocumentList } from "../components/document-list";
import { SideBar } from "../components/sidebar";
import { SearchHeader } from "../components/search-header";

type ChangeEvent = React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;

function Search(): JSX.Element {
    // Loading state.
    const [isLoading, setIsLoading] = useState(true);
    const [documentation, setDocumentation] = useState<Documentation[]>([]);
    const [searchField, setSearchField] = useState("");

    // Track life cycle of component.
    const mountedRef = useRef(true);

    // Function for retrieving docs from endpoint.
    async function getDocs() {
        const docs = await DocumentService.get();

        // Out if the component is no longer mounted.
        if (mountedRef.current === false) {
            return;
        }

        // Update state.
        setDocumentation(docs);
        setIsLoading(false);
    }

    // Called once when the search component is first mounted.z
    useEffect(() => {
        // Wrap async code in promise handler.
        getDocs().catch((err) => console.error(err));

        // Track mounted state of component.
        return () => {
            mountedRef.current = false;
        };
    }, []);

    function onSearchTextChange(event: ChangeEvent) {
        const input = event?.target.value;
        setSearchField(input);
    }

    // Setup hero with page title and custom table.
    return (
        <div>
            <SideBar />

            <div
                id="content"
                style={{
                    position: "relative",
                    display: "flex",
                    alignItems: "left",
                    width: "100%",
                    height: "100vh",
                }}
            >
                <div
                    id="search"
                    style={{
                        position: "absolute",
                        top: 0,
                        alignItems: "center",
                        margin: "auto",
                    }}
                >
                    <SearchHeader />

                    <div
                        style={{
                            width: "100%",
                            margin: "auto",
                            paddingLeft: "2em",
                            paddingTop: "0.5em",
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <span style={{ paddingRight: "0.5em" }}>
                                <Icon name="ActionsSearch" variant="solid" />
                            </span>

                            <Textbox
                                onChange={onSearchTextChange}
                                placeholder="Enter search terms..."
                                autoFocus
                            />
                        </div>

                        <DocumentList
                            documents={documentation}
                            isLoading={isLoading}
                            filterText={searchField}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export { Search };
